<template>
  <b-form class="mt-3" @submit="onSubmitForm">
    <b-row>
      <b-col cols="12" md="6" v-if="isSecretary()">
        <b-form-group
          label="ชื่อเจ้าหน้าที่ผู้อนุมัติเอกสาร"
          label-for="officer"
        >
          <vue-select
            label="text"
            v-model="officer"
            :options="officers"
            @input="selectOnInput"
          />
        </b-form-group>
      </b-col>
      <b-col cols="12" md="6">
        <InputFilter :filter="search[0]" />
      </b-col>
      <b-col cols="12" md="3">
        <InputFilter :filter="search[1]" />
      </b-col>

      <b-col cols="12" md="3">
        <InputFilter :filter="search[2]" />
      </b-col>

      <!-- TEST SELECT -->
    </b-row>
    <!-- Action Buttons -->
    <div class="text-center pt-1">
      <b-button
        variant="primary"
        class="mb-1 mb-sm-0 mr-0 mr-sm-1"
        type="submit"
      >
        ค้นหา
      </b-button>
      <b-button
        variant="outline-secondary"
        type="reset"
        @click="onResetBtnClicked"
      >
        ล้าง
      </b-button>
    </div>
  </b-form>
</template>

<script>
import {
  BButton,
  BAvatar,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BFormCheckbox,
} from "bootstrap-vue";
import VueSelect from "vue-select";
import * as storeMaster from "@/store/api/master/index.js";
import InputFilter from "../../../filters/components/InputFilter.vue";
import * as userData from "@/auth/localStorageUtils.js";
import appsettings from "@/store/app-settings";

export default {
  components: {
    BButton,
    BAvatar,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BFormCheckbox,
    VueSelect,
    InputFilter,
  },
  props: {
    mode: {
      type: String,
      required: true,
    },
  },
  setup(props) {
    const options = [
      { label: "อยู่ระหว่างดำเนินการ", value: "1" },
      { label: "ส่งต่อเรื่อง", value: "2" },
      { label: "ผู้ร้องยุติเรื่อง", value: "3" },
      { label: "ยุติเรื่องในชั้นเจ้าหน้าที่", value: "4" },
      { label: "ยุติเรื่องในชั้นบังคับคดี", value: "5" },
    ];

    const officers = [{ text: "ชื่อเจ้าหน้าที่ผู้รับเรื่อง", value: "" }];

    const searchList = [
      {
        id: "receiveCode",
        label: "เลขรับแจ้ง / เลขสารบัญ",
        value: "",
        class: "",
        style: "",
        placeholder: "กรอกเลขรับแจ้ง / เลขสารบัญ",
        type: "text",
        options: [],
      },
      {
        id: "startdateSearch",
        label: "ช่วงเวลาดำเนินการ",
        value: "",
        class: "",
        style: "",
        placeholder: "จากวันที่",
        type: "date",
        options: [],
      },
      {
        id: "enddateSearch",
        label: "ถึง",
        value: "",
        class: "",
        style: "",
        placeholder: "ถึงวันที่",
        type: "date",
        options: [],
      },
    ];

    return {
      options,
      search: searchList,
      officers,
      officer: {
        text: "ชื่อเจ้าหน้าที่ผู้อนุมัติเอกสาร",
        value: userData.userId(),
      },
      props,
    };
  },
  mounted() {
    if (this.isSecretary()) {
      this.getSecretary();
      //this.getOfficer();
    } else {
      this.getOfficer();
    }
    // this.getOfficer();
    //this.getSecretary();

    this.onSearchBtnClicked();
  },
  methods: {
    isSecretary() {
      return userData.isSecretary();
    },
    onSubmitForm(e) {
      e.preventDefault();
      this.onSearchBtnClicked();
    },
    onResetBtnClicked() {
      this.search[0].value = null;
      this.search[1].value = null;
      this.search[2].value = null;
    },
    onSearchBtnClicked() {
      console.log("props.mode", this.props.mode);

      if (this.isSecretary()) {
        const params = {
          code: this.search[0].value,
          startDate: this.search[1].value,
          endDate: this.search[2].value,
          userId: this.officer.value,
        };

        //console.log('onSearchBtnClicked', params)

        this.$emit("handleSubmit", params);
      } else {
        const params = {
          code: this.search[0].value,
          startDate: this.search[1].value,
          endDate: this.search[2].value,
          userId: userData.userId(),
        };

        //console.log('onSearchBtnClicked', params)

        this.$emit("handleSubmit", params);
      }
    },
    getOfficer() {
      const _this = this;

      storeMaster
        .getOfficerInfoAll()
        .then(function(response) {
          var setDataList = [];

          response.data.data.forEach((o) => {
            var setData = {};
            setData.value = o.user_id;
            setData.text = o.title_name + " " + o.fname + " " + o.lname;

            setDataList.push(setData);
          });

          const officerUnique = [
            ...new Map(
              setDataList.map((item) => [item["value"], item])
            ).values(),
          ];

          //_this.officers.push(...setDataList);
          _this.officers = officerUnique;

          _this.$forceUpdate();
        })
        .catch(function(error) {
          // handle error
          console.log("error", error);
        });
    },
    getSecretary() {
      const _this = this;

      var setDataList = [];

      const dataStorage = JSON.parse(localStorage.getItem("userData"));

      if (userData.isAdminRole()) {
        // กรณี login ด้วย superadmin แล้วเลือกรายชื่อเจ้าหน้าที่

        var dataSecretary = dataStorage.selectUserRole.secretaryList;
        dataSecretary.forEach((o) => {
          var setData = {};
          setData.value = o.userId;
          setData.text = o.fullName;

          setDataList.push(setData);
        });
      } else {
        // กรณี login ด้วย user ของเจ้าหน้าที่เอง

        for (
          let i = 0;
          i < dataStorage.userDepartmentRole.departmentRoles.length;
          i++
        ) {
          const dataDepartmentRoles =
            dataStorage.userDepartmentRole.departmentRoles[i];

          for (let j = 0; j < dataDepartmentRoles.roles.length; j++) {
            if (
              dataDepartmentRoles.roles[j].value.toLowerCase() ===
              appsettings.complaintRoleId.secretary
            ) {
              var dataSecretary = dataDepartmentRoles.roles[j].secretaryList;

              dataSecretary.forEach((o) => {
                var setData = {};
                setData.value = o.userId;
                setData.text = o.fullName;

                setDataList.push(setData);
              });
            }
          }
        }
      }

      const officerUnique = [
        ...new Map(setDataList.map((item) => [item["text"], item])).values(),
      ];

      _this.officers = officerUnique;
      _this.$forceUpdate();
    },
    selectOnInput() {
      this.$forceUpdate();
    },
  },
};
</script>
<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
